import React from "react";

export default function NotFound() {
  return <p className="App-intro">404 Page Not Found</p>;
}
